import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import Autocomplete, { AutocompleteChangeDetails, AutocompleteChangeReason, AutocompleteRenderGetTagProps } from "@mui/material/Autocomplete";
import close from "../../asset/image/close.svg";
import "./EditGroup.css";
import { getSiteDevices, updateGroup } from "../../actions/Users/authenticateInventory";
import _ from "lodash";

const EditGroup = (props) => {
    const { authReducer, editGroupPopup, setEditGroupPopup, selectedRow, getSiteDevices, updateGroup } = props;

    const [groupName, setGroupName] = useState<string>(selectedRow["groupName"])
    const [devices, setDevices] = useState<any[]>([])
    const [selectedDevices, setSelectedDevices] = useState<any[]>([])
    const [selectedOu] = useState<any>({
        "id": selectedRow["dpId"],
        "name": selectedRow["dpName"]
    })
    const [isAllSelected, setIsAllSelected] = useState(false)

    interface DeviceInterface {
        dpId: string;
        siteId: string;
        deviceId: string;
        isAllSelected: boolean
    }

    useEffect(() => {
        if (!_.isEmpty(selectedOu) && selectedOu.hasOwnProperty("id")) {
            clearData()
            getSiteDevices(selectedOu.id)
        }
    }, [selectedOu])

    useEffect(() => {
        if (!_.isEmpty(authReducer.getDpDevices)) {
            const data = authReducer.getDpDevices?.data;
            if (data) {
                const cols: string[] = data.columns || [];
                const siteIdIdx = cols.indexOf('site_id');
                const deviceIdIdx = cols.indexOf('device_id');
                const deviceNameIdx = cols.indexOf('device_name');
                const locationMap: { [id: string]: string } = {};
                (authReducer.getVesselsListing?.locations || []).forEach((loc: any) => {
                    locationMap[loc.id] = loc.name;
                });
                const _devices: any = [];
                const _selectedDevices: any = [];
                (data.rows || []).forEach((r: any[]) => {
                    const siteId = siteIdIdx >= 0 ? r[siteIdIdx] : r[0];
                    const deviceId = deviceIdIdx >= 0 ? r[deviceIdIdx] : r[1];
                    const deviceName = deviceNameIdx >= 0 ? r[deviceNameIdx] : r[2];
                    const device = {
                        dpId: selectedOu.id,
                        dpName: selectedOu.name,
                        siteId,
                        siteName: locationMap[siteId] || siteId,
                        deviceId,
                        deviceName
                    };
                    if (selectedRow["devices"].find((d: any) => d.id === deviceId)) {
                        _selectedDevices.push(device);
                    }
                    _devices.push(device);
                });
                setDevices(_devices);
                setSelectedDevices(_selectedDevices);
            } else {
                setDevices([]);
                setSelectedDevices([]);
            }
        }
    }, [authReducer.getDpDevices])

    const clearData = () => {
        setDevices([])
        setSelectedDevices([])
    }
    const closeDialog = () => {
        clearData()
        setEditGroupPopup(false)
    }

    const update = () => {
        let payload = {
            "id": selectedRow["groupId"],
            "name": groupName,
            "devices": selectedDevices
        }
        setEditGroupPopup(false)
        updateGroup(selectedRow["dpId"], payload)
    }

    const handleSelectedDevicesChange = (event: React.SyntheticEvent<Element, Event>, value: unknown, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<unknown> | undefined) => {
        if (reason === 'selectOption' || reason === 'removeOption') {
            let _value = value as DeviceInterface[];
            setSelectedDevices(_value);
            if (_value.length === 1) {
                if (_value[0].isAllSelected) {
                    // setIsAllSelected(true)
                } else {
                    // setIsAllSelected(false)
                }
            }
        } else if (reason === 'clear') {
            setSelectedDevices([]);
        }
    };
    return (
        <Dialog
            open={editGroupPopup}
            onClose={() => { closeDialog() }}
            aria-labelledby='form-dialog-title'
            maxWidth={'md'}
            className='create-default-config-container group-actions-tab-create-group-popup menuScroll'
        >
            <div>
                <DialogTitle className='create-default-config-title'>
                    <span>Edit Group</span>
                    <img src={close} title="Close" onClick={() => { closeDialog() }} />
                </DialogTitle>
                <DialogContent className='create-default-config-content'>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} className='name-input-default-config name-margin-top'>
                            <span>Name</span>
                            <Grid item xs={6} sm={6} md={4} lg={4}>
                                <Box>
                                    {<TextField
                                        variant="outlined"
                                        type="search"
                                        placeholder="Group Name"
                                        onChange={(event) => {
                                            setGroupName(event.target.value);
                                        }}
                                        value={groupName}
                                        InputProps={{
                                            autoComplete: 'none',
                                            className: "serachBar name-config-default group_name",
                                        }}

                                    />}
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} className='name-input-default-config create-config-table select_devices'>
                            <span>Devices</span>
                            <Autocomplete
                                freeSolo
                                multiple
                                limitTags={1}
                                disableCloseOnSelect={true}
                                value={[...selectedDevices.reverse()]}
                                options={devices}
                                getOptionLabel={(option: any) => option.deviceName}
                                getOptionDisabled={option => {
                                        if (selectedDevices.length > 0) {
                                            if (selectedDevices[0]['deviceId'].slice(0, 2) == option['deviceId'].slice(0, 2)) {
                                                return false
                                            }
                                            return true
                                        }
                                        return false
                                    }
                                }
                                renderOption={(props, option) => {
                                    const key = `listItem-${props["data-option-index"]}-${option.siteId + "_" + option.deviceId}`
                                    return (<li {...props} title={option.siteName} key={key}>{option.deviceName}</li>)
                                }}
                                onChange={handleSelectedDevicesChange}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" className={selectedDevices.length > 0 ? "search-or-select" : ""} placeholder="Search or Select" type="search" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} className="dialog-actions">
                            <Button variant="outlined" className={!_.isEmpty(groupName) && selectedDevices.length > 0 ? "create" : "create disable"} onClick={() => { update() }}>Update</Button>
                            <Button variant="outlined" onClick={() => { closeDialog() }} >Cancel</Button>
                        </Grid>
                    </Grid>
                </ DialogContent>
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, {
        getSiteDevices, updateGroup
    })(EditGroup)
);